import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/location.png'


const _withScopeId = n => (_pushScopeId("data-v-0cb5fbe7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aboutus page-abouts" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "path" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前位置:", -1))
const _hoisted_6 = { class: "company rounded" }

import { ref, onMounted, onUnmounted, watch, nextTick } from "vue";
import type { TabsPaneContext } from "element-plus";
// import CompanyBackground from "./components/CompanyBackground.vue";
import CompanyIntro from "./components/CompanyIntro.vue";
import DevelopmentHistory from "./components/DevelopmentHistory.vue";
// import QualifiyHonors from "./components/QualifiyHonors.vue";
import InformationDisclosure from "./components/InformationDisclosure.vue";
import AdvComp from "./components/AdvComp.vue";
import ContactUs from "./components/ContactUs.vue";
import { getLeaf, getPage } from "@/http/api/index";
import useGetContext from "@/hooks/useGetContext";
import { IItem } from "@/interface/article.d";
import useGetQRCodes from "@/hooks/useGetQRCodes";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'aboutUs',
  setup(__props) {

const { proxy, getMenuId } = useGetContext();
const { qrCodesObj } = useGetQRCodes();
const router = useRouter();
const tabMaps = {
  background: "公司背景",
  intro: "公司概况",
  honors: "资质荣誉",
};

const activeName = ref("公司概况");

const companyBgList = ref<IItem[]>([]);
const companyIntroList = ref<IItem[]>([]);
const developmentHistoryList = ref<IItem[]>([]);
const qualifiyHonorsList = ref<IItem[]>([]);
const contactUs = ref<IItem[]>([]);
const informationDisclosureList = ref<IItem[]>([]);

const tabList = ref<IItem[]>([]);

const handleClick = (tab: TabsPaneContext, event: Event) => {
  handleTabChange(tab.paneName);
};

function getNewsInfo() {
  const { newMenu } = getMenuId("/aboutus") || {};
  getLeaf({ menuId: newMenu.id }).then((res: any) => {
    if (res.code === 200) {
      const list = res.data.leftList;
      tabList.value = list;
      const tarValue = list.find((item) => item.title === activeName.value);
      getSelPage(tarValue.id, 1);
    }
  });
}
onMounted(() => {
  const { newMenu } = getMenuId("/aboutus") || {};
  const tab = router.currentRoute.value.query?.tab as string;
  if (tab) {
    activeName.value = tabMaps[tab] || "公司背景";
  }
  if (newMenu?.id) {
    getNewsInfo();
  } else {
    proxy.$eventBus.on("navMenuInit", getNewsInfo);
  }
});
onUnmounted(() => {
  proxy.$eventBus.off("navMenuInit", getNewsInfo);
});

const handleTabChange = (name) => {
  const tarValue = tabList.value.find((item) => item.title === name);
  if(tarValue?.title === '信息公开') {
    const arr = tarValue.leftList?.map(item => item.id);
    const apiArr = arr.map(item => getPage({
      menuId: item,
      pageNum: 1,
      pageSize: 20,
    }))
    handleInfoDisclosure(apiArr, tarValue.leftList);
    return
  }
  if (tarValue?.id) {
    getSelPage(tarValue?.id, 1);
  }
};
const handleInfoDisclosure = (arr, infoList) => {
  Promise.all(arr).then((res) => {
    const list: any = res.map((item, index) => {
      return {
        title: infoList[index].title,
        list: item.rows,
      };
    });
    informationDisclosureList.value = list;
  });
};

const getSelPage = (menuId, pageNum) => {
  getPage({
    menuId,
    pageNum,
    pageSize: 20,
  }).then((res: any) => {
    if (res.code === 200) {
      switch (activeName.value) {
        case "公司背景":
          companyBgList.value = res.rows;
          break;
        case "公司概况":
          companyIntroList.value = res.rows;
          break;
        case "大事记":
          developmentHistoryList.value = res.rows;
          break;
        case "资质荣誉":
          qualifiyHonorsList.value = res.rows;
          break;
        case "联系我们":
          contactUs.value = res.rows;
          break;
        // case "信息公开":
        //   informationDisclosureList.value = res.rows;
        //   break;
      }
    }
  });
};

watch(
  () => router.currentRoute.value,
  () => {
    nextTick(() => {
      const tabCur = router.currentRoute.value.query?.tab as string;
      const tabIndex = tabMaps[tabCur] || "公司背景";
      activeName.value = tabIndex;
      handleTabChange(tabIndex);
    });
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AdvComp),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", null, "首页 > 关于我们 > " + _toDisplayString(activeName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          type: "card",
          class: "tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "公司概况",
              name: "公司概况"
            }, {
              default: _withCtx(() => [
                _createVNode(CompanyIntro, { dataList: companyIntroList.value }, null, 8, ["dataList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "大事记",
              name: "大事记"
            }, {
              default: _withCtx(() => [
                _createVNode(DevelopmentHistory, { dataList: developmentHistoryList.value }, null, 8, ["dataList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "资质荣誉",
              name: "资质荣誉"
            }, {
              default: _withCtx(() => [
                _createVNode(DevelopmentHistory, { dataList: qualifiyHonorsList.value }, null, 8, ["dataList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "信息公开",
              name: "信息公开"
            }, {
              default: _withCtx(() => [
                _createVNode(InformationDisclosure, { dataList: informationDisclosureList.value }, null, 8, ["dataList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "联系我们",
              name: "联系我们"
            }, {
              default: _withCtx(() => [
                _createVNode(ContactUs, {
                  dataList: contactUs.value,
                  qrCodesObj: _unref(qrCodesObj)
                }, null, 8, ["dataList", "qrCodesObj"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})